import type { ArtifactFrameMeta } from './use-artifact-lineage';
import type { SurfaceContext } from './types';

/**
 * The `artifact` surface_context both the artifact viewer and the chat-home
 * artifact pane ground the agent in.
 *
 * `context_key` comes from the lineage, not the raw artifact id: editing in
 * place mints a new artifact id for the same document, and the key is what
 * keeps the next version from reading as a different file. The chat frames'
 * own title/type take precedence over the artifact row's, since a frame can
 * rename an artifact (or change its type on a regenerate) before the row
 * catches up.
 */
export function buildArtifactSurfaceContext(params: {
  artifactId: string;
  artifactContextKey: (artifactId: string) => string;
  meta: ArtifactFrameMeta | undefined;
  artifact:
    | { title?: string; type?: string; source_workflow_id?: string }
    | undefined;
}): SurfaceContext {
  const { artifactId, artifactContextKey, meta, artifact } = params;
  return {
    surface: 'artifact',
    artifact_id: artifactId,
    context_key: artifactContextKey(artifactId),
    title: meta?.title ?? artifact?.title,
    artifact_type: meta?.artifact_type ?? artifact?.type,
    ...(artifact?.source_workflow_id
      ? { workflow_id: artifact.source_workflow_id }
      : {}),
  };
}
